/* eslint-disable class-methods-use-this */
/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.currentVariantMetafields = null;

      // Performance optimizations: Cache DOM queries and add request management
      this._mediaSectionElement = null;
      this._mediaTargetElement = null;
      this._mediaFetchController = null;
      this._variantSectionsBundleCache = new Map();
      this._productMediaPopupInitialized = false;
      this._changeListenerBound = false;

      // May be incomplete for dynamically inserted nodes (constructor runs before connect).
      this._resolveFormContext();
    }

    /**
     * Resolve parent form / container after the element is in the DOM.
     * Required for dispensers appended into [data-additional-dispender-wrap].
     */
    _resolveFormContext() {
      const productCardRoot = this.closest('[data-product-card]');
      this.formParent = this.closest('product-form') || productCardRoot?.querySelector('product-form') || null;
      this.form = this.formParent?.querySelector('form') || null;
      const formatAttr =
        this.formParent?.getAttribute('data-format') ||
        this.closest('[data-format]')?.getAttribute('data-format');
      this.formType = formatAttr || null;
      this.variant_json = this.querySelector('[data-variantJSON]');
      this.label = this.formParent?.closest('[data-format]') || null;

      this.container =
        this.formType === 'product-card'
          ? productCardRoot || this.closest('[data-product-card]')
          : this.closest('[data-product-container]');
      if (this.closest?.('[data-product-quickview]')) {
        this.container =
          this.formType === 'quickview'
            ? this.closest('[data-product-quickview]')
            : this.closest('[data-product-container]');
      }
    }

    connectedCallback() {
      this._resolveFormContext();
      this.updateSwatchLabel();
      if (this.formType === 'product-page') this.onVariantChange('load');

      if (this._changeListenerBound) return;
      this._changeListenerBound = true;

      this.addEventListener('change', (evt) => {
        const target = this.getInputForEventTarget(evt.target);
        if (!window.hasUserModifiedAccessoryVariants) {
          if (evt.isTrusted && target.closest('[data-accessories-wrap]')) {
            window.hasUserModifiedAccessoryVariants = true
          }
        }
        eventBus.publish(PUB_SUB_EVENTS.optionChange, {
          data: {
            target,
            selectedOptionsId: this.optionValues,
          }
        });
        this.onVariantChange();
        this._manageAccessoriesItem(this.label);
      });
    }

    updateSwatchLabel(){
      const colorSwatchContainer = this.querySelector('.color-swatch');
      if(colorSwatchContainer){
        const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
        colorSwatches.forEach(swatch => {
          const swatchInput = swatch.querySelector('input[type="radio"]');
          if (!swatchInput) {
            return;
          }
          const colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
          const swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
        });
      }
    }

    _updateDispenserPlainPriceForVariant(wrap, variant) {
      if (!wrap || !variant) return;

      const plainPrice = wrap.querySelector('[data-price-element="1"]');
      if (!plainPrice) return;

      plainPrice.classList.remove('d-none');
      plainPrice.setAttribute('data-product-price', variant.price);

      const currentPriceEl = plainPrice.querySelector('.current-price');
      if (currentPriceEl) {
        currentPriceEl.classList.add('fs-15-14', 'fw-medium', 'text-black');
        currentPriceEl.textContent = `+ ${Utility.formatMoney(variant.price, window.globalSpace.money_format)}`;
      }

      const compareEl = plainPrice.querySelector('[data-product-compare_price]');
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) {
          compareEl.classList.remove('d-none');
          compareEl.textContent = Utility.formatMoney(variant.compare_at_price, window.globalSpace.money_format);
        }
      } else if (compareEl) {
        compareEl.classList.add('d-none');
      }
    }

    /**
     * Trigger this function variant is changed
     */
    onVariantChange() {
      this._resolveFormContext();
      this.setCurrentVariant();
      this.updateOptionLabel(this.label);
      eventBus.publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          container: this.container,
          variant: this.currentVariant,
        },
      });

      if (this.formType === 'product-page' && this.currentVariant) 
        globalSpace.product.currentVariant = this.currentVariant;
      if(typeof this.formParent?.updateProductDetails == 'function'){
        this.formParent?.updateProductDetails(this.container, this.currentVariant);
      }

      if (this.formType === 'product-page' && this.currentVariant) {
        document.querySelector('[data-currentprice]')?.setAttribute("data-product-price",this.currentVariant.price)
        document.querySelector('[data-compareprice]')?.setAttribute("data-compare-at-price",this.currentVariant.compare_at_price)
        let form_id = this.querySelector(".product-form__input:first-child")?.getAttribute("form");
        document.querySelector('#'+form_id+' [name="id"]')?.setAttribute("data-variant-price",this.currentVariant.price)
        document.querySelector('#'+form_id+' [name="id"]')?.setAttribute("data-variant-compare_price",this.currentVariant.compare_at_price)

        if(document.querySelector(".product_houndsy-water-bowl-bfcm, .product_houndsy-water-bowl")){
          this.isProcessingVariantChange ??= false;
          this.lastProcessedVariant ??= null;

          const variantKey = `${this.currentVariant.option1}_${this.currentVariant.option2}`;
          if (this.isProcessingVariantChange || this.lastProcessedVariant === variantKey) return;
          
          this.isProcessingVariantChange = true;
          this.lastProcessedVariant = variantKey;

          const standardEl = document.querySelector('[data-handle="standard-elevated"]');
          const optionEl = document.querySelector('[data-optionindex="2"]');
          
          if (standardEl) {
            const isEssential = this.currentVariant.option1 == "Essential Series - Black/White" || this.currentVariant.option1 == "Black/White";
            
            optionEl?.classList.toggle("d-none", isEssential);
            
            if (isEssential) {
              standardEl.click();
            } else {
              if (this.currentVariant.option2 == "Standard & Elevated") {
                document.querySelector('[data-optionindex="2"] input.form-control')?.click();
              }
              standardEl.closest("li")?.classList.add("d-none");
            }
          }
          
          this.isProcessingVariantChange = false;
          this.lastProcessedVariant = null;
        }
      }

       if (this.formType && this.formType === "product-card") {
          if (
            this?.classList?.contains("product_kibble_variant_options") &&
            this.currentVariant
          ) {
            const wrapper =
              this.closest('[data-additional-dispender-wrap] .shopify-section') ||
              this.closest('#shopify-section-variant-selection');
            const wrapDispenser = wrapper?.querySelector("[data-wrap-dispenser]");

            if (wrapper && wrapDispenser) {
            if (wrapDispenser.getAttribute("data-enable-metafield-discount") === "false") {
              this._updateDispenserPlainPriceForVariant(wrapDispenser, this.currentVariant);
              const priceInput = wrapper.querySelector('[data-dispenser-id]');
              if (priceInput) {
                priceInput.setAttribute('data-variant-price', this.currentVariant.price);
                priceInput.setAttribute(
                  'data-variant-compare_price',
                  this.currentVariant.compare_at_price ?? this.currentVariant.price
                );
                priceInput.value = this.currentVariant.id;
              }
            } else {
            const usesTieredDiscount = wrapDispenser.hasAttribute("data-tiered-discount-price");
            const kibbleMf = Utility.getVariantMetafieldsCustomFromDom(this.currentVariant.id, this.formParent || wrapper);
            if (kibbleMf && (kibbleMf.tiered_discount_price || kibbleMf.product_discount)) {
              this.currentVariantMetafields = kibbleMf;

              if(usesTieredDiscount){
                const variantPrice = parseFloat(this.currentVariant?.price || 0);
                const firstTierDiscountPercent = parseFloat(this.currentVariantMetafields.tiered_discount_price[0] || 0);
                const lastTierDiscountPercent = parseFloat(this.currentVariantMetafields.tiered_discount_price[1] || 0);
                const kibble_first_discount = (variantPrice * firstTierDiscountPercent) / 100;
                const kibble_last_discount = (variantPrice * lastTierDiscountPercent) / 100;
                const moneyNoDecimalsFormat = (window.globalSpace.money_format || "${{ amount }}")
                  .replace("amount_with_comma_separator", "amount_no_decimals_with_comma_separator")
                  .replace("amount", "amount_no_decimals");


                wrapper.querySelector("[data-first-discont]")?.setAttribute("data-discount-percentage",this.currentVariantMetafields.tiered_discount_price[0])
                wrapper.querySelector("[data-last-discont]")?.setAttribute("data-discount-percentage",this.currentVariantMetafields.tiered_discount_price[1])

                const firstDiscountLabel = wrapper.querySelector("[data-first-discont] .discount-label");
                const lastDiscountLabel = wrapper.querySelector("[data-last-discont] .discount-label");
                if (firstDiscountLabel) {
                  firstDiscountLabel.textContent = `${Utility.formatMoney(kibble_first_discount, moneyNoDecimalsFormat)} OFF`;
                }
                if (lastDiscountLabel) {
                  lastDiscountLabel.textContent = `${Utility.formatMoney(kibble_last_discount, moneyNoDecimalsFormat)} OFF`;
                }
              }else{
                wrapper.querySelector("[data-first-discont]")?.setAttribute("data-discount-percentage",this.currentVariantMetafields.product_discount[0])
                wrapper.querySelector("[data-last-discont]")?.setAttribute("data-discount-percentage",this.currentVariantMetafields.product_discount[1])

                const firstDiscountLabel = wrapper.querySelector("[data-first-discont] .discount-label");
                const lastDiscountLabel = wrapper.querySelector("[data-last-discont] .discount-label");
                if (firstDiscountLabel) {
                  firstDiscountLabel.textContent = this.currentVariantMetafields.product_discount[0]+"% OFF";
                }
                if (lastDiscountLabel) {
                  lastDiscountLabel.textContent = this.currentVariantMetafields.product_discount[1]+"% OFF";
                }
              }
            }

            const current_card_variant = this.currentVariant;
            let current_variant_compare_price = parseInt(current_card_variant?.compare_at_price || current_card_variant?.price || 0);

            if(usesTieredDiscount){
              current_variant_compare_price = parseInt(current_card_variant?.price || 0);
            }

            wrapper.querySelectorAll("[data-discount-percentage]").forEach(target => {
              const discount_percentage = parseFloat(target?.getAttribute("data-discount-percentage")) || 0;

              let compare_price_discount = Math.max( 0, current_variant_compare_price - (current_variant_compare_price * discount_percentage) / 100)
              if(usesTieredDiscount){
                const discountedCents = current_variant_compare_price - (current_variant_compare_price * discount_percentage) / 100;
                compare_price_discount = Math.max(0, Math.ceil(discountedCents / 100) * 100);
              }

              const comparePriceEls = target.querySelectorAll("[data-product-compare_price]");
              if (comparePriceEls.length) {
                comparePriceEls.forEach(el => {
                  el.textContent = Utility.formatMoney(current_variant_compare_price, window.globalSpace.money_format);
                });
              }

              const priceEls = target.querySelectorAll(".discounted-price");
              if (priceEls.length) {
                priceEls.forEach(el => {
                  el.textContent = "+ " + Utility.formatMoney(compare_price_discount, window.globalSpace.money_format);
                });
              }
              target.setAttribute("data-product-price",compare_price_discount);
            })

            const priceInput = wrapper.querySelector('[data-dispenser-id]');
            if (priceInput) {
              priceInput.setAttribute('data-variant-price', this.currentVariant.price);
              priceInput.setAttribute(
                'data-variant-compare_price',
                this.currentVariant.compare_at_price ?? this.currentVariant.price
              );
              priceInput.value = this.currentVariant.id;
            }
            }

            window.templateProductJS?.calculateSubtotal?.();
            }
          }
        }


      this.setCurrentVariantMetafields();

      if (this.formType && this.formType === 'product-card') {

        this.setProductCardHoverImage();

      }

      if (this.formType && this.formType !== 'product-card' && this.container) {

        this.setProductInstallmentForm();

        this.setCurrentVariantShipsInTime();
        
      }

      if (this.formType && this.formType === 'product-card') {
        if(document.querySelector("[data-water-bowl-product]") != null){
          if (document.querySelector('[data-option-value-handle="standard-elevated"]') !== null) {

            const option2Wrap = this.querySelector('[data-optionindex="2"]');
            const select = option2Wrap?.querySelector('[data-select-box]');
            const elevatedOption = option2Wrap?.querySelector('option[data-option-value-handle="standard-elevated"]');

            // Guard flag to prevent recursive change dispatch
            if (typeof this._changingSelect === "undefined") {
              this._changingSelect = false;
            }
            

            if (this.currentVariant.option1 === "Essential Series - Black/White" || this.currentVariant.option1 === "Black/White") {
              // Hide the select box section
              option2Wrap?.classList.add("d-none");

              // If select exists and value is not already "Standard & Elevated"
              if (select && select.value !== "Standard & Elevated" && !this._changingSelect) {
                this._changingSelect = true;
                select.value = "Standard & Elevated";
                select.dispatchEvent(new Event("change", { bubbles: true }));
                setTimeout(() => { this._changingSelect = false; }, 0);

                const bowlSelect = document.querySelector('.card-product-style-upsell[data-water-bowl-product] product-form.product-form [data-optionindex="2"] select');
                if (bowlSelect) {
                  bowlSelect.value = "Standard & Elevated";
                  bowlSelect.dispatchEvent(new Event("change", { bubbles: true }));
                }

              }

            } else {
              // Show the select box section
              option2Wrap?.classList.remove("d-none");

              // If current variant is "Standard & Elevated", reset value to "Standard"
              if (this.currentVariant.option2 === "Standard & Elevated") {
                if (select && select.value !== "Standard" && !this._changingSelect) {
                  this._changingSelect = true;
                  select.value = "Standard";
                  select.dispatchEvent(new Event("change", { bubbles: true }));
                  setTimeout(() => { this._changingSelect = false; }, 0);

                  const bowlSelect = document.querySelector('.card-product-style-upsell[data-water-bowl-product] product-form.product-form [data-optionindex="2"] select');
                  if (bowlSelect) {
                    bowlSelect.value = "Standard";
                    bowlSelect.dispatchEvent(new Event("change", { bubbles: true }));
                  }
                }
              }

              // Hide / disable the "Standard & Elevated" option
              if (elevatedOption) {
                elevatedOption.classList.add("d-none");
                elevatedOption.disabled = true;
                elevatedOption.hidden = true;
                elevatedOption.style.display = "none";
              }
            }
          }
        }
      }

      // Single bundle fetch for gallery media + variant replace sections (was 2–3 parallel requests)
      if (this.formType === 'product-page' && this.currentVariant) {
        const current_color_name = window.globalSpace.current_color_name;
        const new_selected_color_name = this.currentVariant.option1;
        if (current_color_name !== new_selected_color_name) {
          window.globalSpace.current_color_name = new_selected_color_name;
          this._fetchAndApplyVariantBundle();
        }
      }
    }

    get selectedOptionValues() {
      return Array.from(this.querySelectorAll('select.variant_selector, fieldset input[type="radio"]:checked')).map(({ value }) => value);
    }

    _showMediaLoadingState() {
      if (!this._mediaTargetElement) {
        this._mediaTargetElement = document.querySelector("[data-variant-content-replace-media]");
      }
      if (this._mediaTargetElement) {
        this._mediaTargetElement.classList.add('variant-loading');
        // Keep current image visible but add a subtle loading indicator
        this._mediaTargetElement.style.transition = 'opacity 0.15s';
      }
    }

    _hideMediaLoadingState() {
      if (this._mediaTargetElement) {
        this._mediaTargetElement.classList.remove('variant-loading');
      }
    }

    _collectVariantSectionBundleIds() {
      if (!this._mediaSectionElement) {
        this._mediaSectionElement = document.querySelector('[data-product-section-media]');
      }
      const rawMediaId = this._mediaSectionElement?.getAttribute('data-section');
      const mediaSectionId = rawMediaId && String(rawMediaId).trim() ? rawMediaId : null;
      const add = (set, attr) => {
        document.querySelectorAll(`[${attr}]`).forEach((el) => {
          const id = el.getAttribute('data-section');
          if (id) set.add(id);
        });
      };
      const ids = new Set();
      if (mediaSectionId) ids.add(mediaSectionId);
      add(ids, 'data-product-section');
      add(ids, 'data-product-section-two');
      return { mediaSectionId, allIds: Array.from(ids) };
    }

    _applyReplaceSectionsFromJSON(responseJSON, parser, sectionAttr, replaceAttr) {
      const sections = document.querySelectorAll(`[${sectionAttr}]`);
      if (sections.length === 0) return;

      const sectionIds = Array.from(sections).map((section) => section.getAttribute('data-section'));
      sectionIds.forEach((sectionId) => {
        const newHTML = responseJSON[sectionId];
        if (!newHTML) return;

        const doc = parser.parseFromString(newHTML, 'text/html');
        const newElements = doc.querySelectorAll(`[${replaceAttr}]`);
        const currentSection = document.getElementById(`shopify-section-${sectionId}`);
        if (!currentSection) return;

        const currentElements = currentSection.querySelectorAll(`[${replaceAttr}]`);
        newElements.forEach((newEl, i) => {
          const oldEl = currentElements[i];
          if (oldEl) oldEl.replaceWith(newEl);
        });
      });
    }

    _afterVariantSectionsUpdated() {
      if (typeof lazyImageObserver !== 'undefined' && lazyImageObserver.observe) {
        lazyImageObserver.observe();
      }

      const videoButtons = document.querySelectorAll('.ugc-video-wrap');
      if (videoButtons.length > 0) {
        videoButtons.forEach((btn) => {
          if (!btn.hasAttribute('data-listener-attached')) {
            btn.setAttribute('data-listener-attached', 'true');
            btn.addEventListener('click', (event) => {
              event.preventDefault();
              const target = event.currentTarget;
              document.querySelector('#UGC-PopupModal-video .modal')?.classList.add('open');
              document.querySelector('site-overlay')?.classList.add('overlay--body');
              document.body.classList.add('scroll-fixed');

              const indexSlide = parseInt(target.getAttribute('data-index'), 10) - 1;
              const swiperInstance = document.querySelector('.block__social-ugc-video-slider')?.swiper;
              if (swiperInstance) swiperInstance.slideTo(indexSlide);
            });
          }
        });
      }

      if (typeof this.happypetparentsvideo === 'function') {
        this.happypetparentsvideo();
      }
    }

    /**
     * Shopify Section Rendering API allows at most 5 section IDs per request; exceeding returns HTTP 400.
     * @see https://shopify.dev/docs/api/ajax/section-rendering
     */
    _fetchMergedVariantSectionsJSON(variantId, allIds, signal) {
      const MAX_SECTIONS_PER_REQUEST = 5;
      const path = window.location.pathname;
      const chunks = [];
      for (let i = 0; i < allIds.length; i += MAX_SECTIONS_PER_REQUEST) {
        chunks.push(allIds.slice(i, i + MAX_SECTIONS_PER_REQUEST));
      }
      return Promise.all(
        chunks.map((ids) => {
          const sectionsParam = ids.map((id) => encodeURIComponent(String(id))).join(',');
          const url = `${path}?variant=${variantId}&sections=${sectionsParam}`;
          return fetch(url, { signal }).then((response) => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.json();
          });
        })
      ).then((parts) => Object.assign({}, ...parts));
    }

    _fetchAndApplyVariantBundle() {
      if (!this.currentVariant) return;

      const variantId = this.currentVariant.id;
      const { mediaSectionId, allIds } = this._collectVariantSectionBundleIds();

      if (allIds.length === 0) {
        this._afterVariantSectionsUpdated();
        return;
      }

      if (this._mediaFetchController) {
        this._mediaFetchController.abort();
      }

      const sortedKey = [...allIds].sort().join(',');
      const cacheKey = `${variantId}_${sortedKey}`;

      const parser = new DOMParser();

      const applyReplaceSections = (responseJSON) => {
        this._applyReplaceSectionsFromJSON(responseJSON, parser, 'data-product-section', 'data-variant-content-replace');
        this._applyReplaceSectionsFromJSON(responseJSON, parser, 'data-product-section-two', 'data-variant-content-replace-two');
      };

      const finishBundle = (responseJSON) => {
        applyReplaceSections(responseJSON);
        this._hideMediaLoadingState();
        this._afterVariantSectionsUpdated();
      };

      if (this._variantSectionsBundleCache.has(cacheKey)) {
        const responseJSON = this._variantSectionsBundleCache.get(cacheKey);
        if (mediaSectionId && responseJSON[mediaSectionId]) {
          this._preloadMediaImages(responseJSON[mediaSectionId]).then(() => {
            this._updateMediaContent(responseJSON[mediaSectionId]);
            finishBundle(responseJSON);
          });
        } else {
          finishBundle(responseJSON);
        }
        return;
      }

      if (mediaSectionId) {
        this._showMediaLoadingState();
      }

      this._mediaFetchController = new AbortController();
      const signal = this._mediaFetchController.signal;

      this._fetchMergedVariantSectionsJSON(variantId, allIds, signal)
        .then((responseJSON) => {
          this._variantSectionsBundleCache.set(cacheKey, responseJSON);
          if (this._variantSectionsBundleCache.size > 10) {
            const firstKey = this._variantSectionsBundleCache.keys().next().value;
            this._variantSectionsBundleCache.delete(firstKey);
          }

          if (mediaSectionId && responseJSON[mediaSectionId]) {
            return this._preloadMediaImages(responseJSON[mediaSectionId]).then(() => {
              this._updateMediaContent(responseJSON[mediaSectionId]);
              finishBundle(responseJSON);
            });
          }
          finishBundle(responseJSON);
          return Promise.resolve();
        })
        .catch((error) => {
          this._hideMediaLoadingState();
          if (error.name !== 'AbortError') {
            console.error('Error updating product details:', error);
          }
        })
        .finally(() => {
          this._mediaFetchController = null;
        });
    }

    _preloadMediaImages(ProductMedia) {
      return new Promise((resolve) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(ProductMedia, "text/html");
        const tempContainer = doc.querySelector("[data-variant-content-replace-media]");
        
        if (!tempContainer) {
          resolve();
          return;
        }

        // Cap preloads so we do not compete with LCP / flood the network (gallery has many slides)
        const maxPreloadImages = 6;
        const images = tempContainer.querySelectorAll('img[data-src], img[srcset], picture img');
        const imagePromises = [];

        images.forEach((img, idx) => {
          if (idx >= maxPreloadImages) return;
          // Get the actual image source
          const src = img.getAttribute('data-src') || img.getAttribute('src') || img.src;
          const srcset = img.getAttribute('data-srcset') || img.getAttribute('srcset');
          
          if (src && !src.includes('placeholder') && !src.includes('data:')) {
            const imagePromise = new Promise((imgResolve) => {
              const preloadImg = new Image();
              preloadImg.onload = () => imgResolve();
              preloadImg.onerror = () => imgResolve(); // Resolve even on error to not block
              
              // Preload the main image
              if (srcset) {
                // Extract first src from srcset for faster loading
                const firstSrc = srcset.split(',')[0].trim().split(' ')[0];
                preloadImg.src = firstSrc || src;
              } else {
                preloadImg.src = src;
              }
            });
            imagePromises.push(imagePromise);
          }
        });

        // Wait for all images or timeout after 300ms (don't wait too long - prioritize speed)
        Promise.race([
          Promise.all(imagePromises),
          new Promise(resolve => setTimeout(resolve, 300))
        ]).then(() => resolve());
      });
    }

    _updateMediaContent(ProductMedia) {
      // Cache target element query
      if (!this._mediaTargetElement) {
        this._mediaTargetElement = document.querySelector("[data-variant-content-replace-media]");
      }
      
      if (!this._mediaTargetElement) return;

      // Use DOMParser for safe parsing (faster than innerHTML for large content)
      const parser = new DOMParser();
      const doc = parser.parseFromString(ProductMedia, "text/html");
      const newContent = doc.querySelector("[data-variant-content-replace-media]");
      
      if (!newContent) return;

      // Batch DOM operations for better performance - use replaceWith for single operation
      const clonedContent = newContent.cloneNode(true);
      
      // Replace immediately - images are already preloaded
      this._mediaTargetElement.replaceWith(clonedContent);
      
      // Update cached reference to the new element
      this._mediaTargetElement = clonedContent;

      // Observe new images for lazy loading - batch observe operations
      if (typeof lazyImageObserver !== "undefined" && lazyImageObserver.observe) {
        // Use the underlying IntersectionObserver if available for better performance
        if (lazyImageObserver.observer) {
          const newImages = this._mediaTargetElement?.querySelectorAll('.lozad:not([data-loaded])');
          if (newImages && newImages.length > 0) {
            // Batch observe all images at once
            newImages.forEach(img => {
              lazyImageObserver.observer.observe(img);
            });
          }
        } else {
          // Fallback to re-observe all if observer not available
          lazyImageObserver.observe();
        }
      }
      
      // Initialize popup only once
      this.productMediapopup();
    }

    productMediapopup() {
      // Early return if already initialized
      if (this._productMediaPopupInitialized) return;

      const modal = document.getElementById('PopupModal-video');
      const modalInner = modal?.querySelector('.modal');
      const overlay = document.querySelector('site-overlay');
      const videoContainer = modal?.querySelector('.video-container') || modal; // fallback if container missing

      if (!modal || !modalInner || !overlay || !videoContainer) return;

      // 🔹 Create reusable iframe and video elements (better than recreating on each click)
      const iframeEl = document.createElement('iframe');
      iframeEl.className = 'w-100 h-100';

      const videoEl = document.createElement('video');
      videoEl.setAttribute('controls', '');
      videoEl.setAttribute('autoplay', '');
      videoEl.setAttribute('playsinline', '');

      function openModal(videoSrc) {
        if (!videoSrc) return;

        // 🧹 Clear previous content
        videoContainer.innerHTML = '';

        // 🔸 Detect Vimeo or regular video
        if (/vimeo\.com/.test(videoSrc)) {
          iframeEl.src = videoSrc;
          videoContainer.appendChild(iframeEl);
        } else {
          videoEl.src = videoSrc;
          videoContainer.appendChild(videoEl);
        }

        // 🪟 Show modal
        modal.style.display = 'block';
        modalInner.classList.add('open');
        overlay.classList.add('overlay--body');
        document.body.classList.add('scroll-fixed');
      }

      function closeModal() {
        modal.style.display = 'none';
        modalInner.classList.remove('open');
        overlay.classList.remove('overlay--body');
        document.body.classList.remove('scroll-fixed');

        // ⏹️ Stop video playback when closing
        iframeEl.src = '';
        videoEl.pause();
        videoEl.src = '';
      }

      // ✅ Event delegation for better performance - only attach once
      if (!document.body.hasAttribute('data-media-popup-listener')) {
        document.body.setAttribute('data-media-popup-listener', 'true');
        document.body.addEventListener('click', e => {
          const opener = e.target.closest('[data-modal-opener="PopupModal-video"]');
          if (opener) {
            const videoSrc = opener.getAttribute('data-video-src');
            if (videoSrc) openModal(videoSrc);
            else console.error('No video source found in data-video-src attribute.');
          }

          // Optional close buttons or overlay click
          if (e.target.matches('[data-modal-close], site-overlay')) {
            closeModal();
          }
        });
      }

      // Mark as initialized
      this._productMediaPopupInitialized = true;
    }


    updatevariantContent() {
      this._fetchAndApplyVariantBundle();
    }

    happypetparentsvideo(){
      if(document.querySelector(".variant-testimonial") != null){
        Promise.all([
          customElements.whenDefined('swiper-container'),
          customElements.whenDefined('custom-video')
        ]).then(function() {
          const swiperTestimonial = document.querySelector('swiper-container.testimonial-slider');
          if (!swiperTestimonial) return;
          Object.assign(swiperTestimonial, {
              slidesPerView: 2,
              spaceBetween: 1,
              centeredSlides: true,
              loop: true,
              effect: 'slide',
              slideActiveClass: 'swiper-slide-active',
              slideToClickedSlide: false,
              centeredSlidesBounds: true,
              scale: 0.9,
              modifier: 1,
              slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
              breakpoints: {
                  320: {
                      slidesPerView: 1.2,
                      spaceBetween: 15
                  },
                  370: {
                      slidesPerView: 1.56,
                      spaceBetween: 15
                  },
                  768: {
                      slidesPerView:2.5,
                      spaceBetween: 30
                  },
                  1200: {
                      slidesPerView: 5,
                      spaceBetween: 30
                  }
              }
          });

          swiperTestimonial.initialize();

          function updateActiveVideoPlayback() {
              document.querySelectorAll('.testimonial-slider swiper-slide').forEach(slide => {
                  const video = slide.querySelector('video');
                  const soundButton = slide.querySelector('.custom-video-sound-button');
                  const customVideoEl = slide.querySelector('custom-video');
                  const isActive = slide.classList.contains('active-video-slide');

                  if (customVideoEl && typeof customVideoEl.toggleView === 'function') {
                      if (isActive) {
                          if (video) {
                              customVideoEl.showContent();
                          } else {
                              customVideoEl.toggleView();
                          }
                          return;
                      }
                      if (video && typeof customVideoEl.hideContent === 'function') {
                          customVideoEl.hideContent();
                      }
                      if (soundButton) {
                          soundButton.classList.remove('sound-on');
                      }
                      return;
                  }

                  if (video) {
                      if (isActive) {
                          if (video.readyState >= 2) {
                              video.play().catch(err => {
                                  console.warn('Video play failed:', err);
                              });
                          } else {
                              video.addEventListener('loadeddata', () => {
                                  video.play().catch(err => {
                                      console.warn('Video play failed:', err);
                                  });
                              }, { once: true });
                          }
                      } else {
                          video.pause();
                          video.muted = true;
                          if (soundButton) {
                              soundButton.classList.remove('sound-on');
                          }
                      }
                  }
              });
          }

          // On Swiper slide change
          swiperTestimonial.swiper.on('slideChange', (e) => {
              setTimeout(() => {
                  swiperTestimonial.querySelectorAll('swiper-slide').forEach(s => {
                      s.classList.remove('active-video-slide');
                  });

                  const activeSlide = swiperTestimonial.querySelector('.swiper-slide-active');
                  if (activeSlide) {
                      activeSlide.classList.add('active-video-slide');
                      updateActiveVideoPlayback();
                  }
              }, 0);
          });

          // On manual slide click
          document.querySelectorAll('.testimonial-slider swiper-slide').forEach(slide => {
              slide.addEventListener('click', function () {
                  document.querySelectorAll('.testimonial-slider swiper-slide').forEach(s => {
                      s.classList.remove('active-video-slide');
                  });

                  this.classList.add('active-video-slide');
                  updateActiveVideoPlayback();
              });
          });

          // Initial setup on load
          const initialActive = document.querySelector('.testimonial-slider .swiper-slide-active');
          if (initialActive) {
              initialActive.classList.add('active-video-slide');
              updateActiveVideoPlayback();
          }

          // Mute/unmute toggle for active video only
          document.querySelectorAll('.custom-video-sound-button').forEach(button => {
              button.addEventListener('click', function () {
                  const wrapper = this.closest('.custom-video-container');
                  if (!wrapper) {
                      console.warn('Wrapper with .custom-video-container not found.');
                      return;
                  }

                  const video = wrapper.querySelector('video');
                  if (!video) {
                      console.warn('No video tag found inside .custom-video-container');
                      return;
                  }

                  // Toggle mute
                  const isMuted = video.muted;
                  video.muted = !isMuted;

                  // Toggle UI class
                  if (video.muted) {
                      this.classList.remove('sound-on');
                  } else {
                      this.classList.add('sound-on');
                  }
              });
          });

          if (document.querySelectorAll('.testimonial-card video').length > 0 && !window.__houndsyTestimonialScrollBound) {
            window.__houndsyTestimonialScrollBound = true;
            let scrollTicking = false;
            window.addEventListener(
              'scroll',
              () => {
                if (scrollTicking) return;
                scrollTicking = true;
                requestAnimationFrame(() => {
                  scrollTicking = false;
                  const testimonialRoot = document.querySelector('.customer-testimonial');
                  if (!testimonialRoot) return;
                  const top = testimonialRoot.offsetTop - testimonialRoot.offsetHeight;
                  const bottom = testimonialRoot.offsetTop + testimonialRoot.offsetHeight;
                  if (window.scrollY < top || window.scrollY > bottom) {
                    document.querySelectorAll('.testimonial-card .custom-video-sound-button.sound-on').forEach((btn) => {
                      btn.click();
                    });
                  }
                });
              },
              { passive: true }
            );
          }
        });
      }
    }

    /**
     * change value of currentVariant when variant being changed 
     */
    setCurrentVariant() {
      this.currentVariant = false;
      const options = this.selectedOptionValues;
      const variants = this._getVariantData();

      variants.find(variant => {
          if (variant.options.every((option, i) => options[i] === option)) {
            this.currentVariant = variant;
          }
      });
    }
  
    setCurrentVariantMetafields() {

      try {

        if (!this.currentVariant || !this.container) {

          return;

        }

        this.currentVariantMetafields =
          Utility.getVariantMetafieldsCustomFromDom(this.currentVariant.id, this.formParent) || {};

      } catch (error) {

        console.error('An unexpected error occurred during the current variant metafields set process.', error)

      }

    }

  setProductCardHoverImage() {

    try {

      if (!this.currentVariant) return;



      const element = this.container.querySelector(`#variant-hover-image-${this.currentVariant.id}`);

      if (!element) return;



      const hoverData = JSON.parse(element.textContent || '{}');

      const hoverImage = hoverData?.hover_image;

      if (!hoverImage) return;



      const imgEl = this.container.querySelector("[secondary-image]");

      if (!imgEl) return;



      // Clear srcset and set the hover image

      imgEl.removeAttribute('srcset');

      imgEl.setAttribute('src', hoverImage.src);

      imgEl.setAttribute('alt', hoverImage.alt || this.currentVariant.name || '');

      if (hoverImage.width) imgEl.setAttribute('width', hoverImage.width);

      if (hoverImage.height) imgEl.setAttribute('height', hoverImage.height);



      // Fallback to featured image if hover image fails to load

      imgEl.onerror = () => {

        console.warn(`Hover image failed to load for variant ID: ${this.currentVariant.id}`);

        if (this.currentVariant?.featured_image) {

          imgEl.setAttribute('src', this.currentVariant.featured_image.src);

          imgEl.setAttribute('alt', this.currentVariant.featured_image.alt || this.currentVariant.name);

          imgEl.setAttribute('width', this.currentVariant.featured_image.width);

          imgEl.setAttribute('height', this.currentVariant.featured_image.height);

        } else {

          imgEl.removeAttribute('src');

          imgEl.removeAttribute('alt');

          imgEl.removeAttribute('width');

          imgEl.removeAttribute('height');

        }

      };

    } catch (error) {

      console.error('Error setting hover image for current variant:', error);

    }

  }



  setCurrentVariantShipsInTime() {

    try {

      if (!this.currentVariant) return;



      const shipInTimeElement = this.container.querySelector('.ship-in-time');

      if (!shipInTimeElement) return;



      const textBlockElement = shipInTimeElement.querySelector('.text-block');

      if (!textBlockElement) return;



      const productHandle = this.currentVariantMetafields?.product_handle;



      if (productHandle === 'houndsy-water-bowl') {

        const shippingMessage = Utility.normalizeMetafieldScalar(
          this.currentVariantMetafields?.shipping_message
        ) || Utility.getShipsSeparatelyForProductHandle(productHandle);



        if (shippingMessage) {

          shipInTimeElement.classList.remove('d-none');

          textBlockElement.textContent = shippingMessage;

        } else {

          shipInTimeElement.classList.add('d-none');

        }

        return;

      }



      const shippingTimeframe = Utility.normalizeMetafieldScalar(
        this.currentVariantMetafields?.shipping_timeframe
      );



      if (Utility.isKibbleSensorHandle(productHandle)) {

        if (shippingTimeframe) {

          shipInTimeElement.classList.remove('d-none');

          textBlockElement.textContent = shippingTimeframe;

        } else {

          shipInTimeElement.classList.add('d-none');

        }

        return;

      }



      const strongElement = textBlockElement.querySelector('strong');

      if (shippingTimeframe) {

        shipInTimeElement.classList.remove('d-none');

        if (strongElement) {

          strongElement.textContent = shippingTimeframe;

        } else {

          textBlockElement.textContent = shippingTimeframe;

        }

      } else if (strongElement) {

        shipInTimeElement.classList.add('d-none');

      }

    } catch (error) {

      console.error('An unexpected error occurred during the current variant ships in time content update.', error);

    }

  }



  setProductInstallmentForm() {

    try {

      if (!this.currentVariant || !this.currentVariant.id) return;



      const installmentVariantInputs = document.querySelectorAll('[data-product-installment-variant-id]');

      if (!installmentVariantInputs.length) return;



      installmentVariantInputs.forEach((inputElement) => {
        inputElement.value = this.currentVariant.id;
        inputElement.dispatchEvent(new Event('change', { bubbles: true }));
      });

      const mainSubtotalEl = document.querySelector('[data-product-sub-total]');
      const subtotalMatch = mainSubtotalEl?.textContent?.match(/[\d,.]+/);
      if (subtotalMatch) {
        const subtotalCents = Utility.parseMoneyToCents(subtotalMatch[0]);
        if (subtotalCents) Utility.syncProductInstallmentSubtotal(subtotalCents);
      } else {
        Utility.syncProductInstallmentSubtotal(this.currentVariant.price);
      }

    } catch (error) {

      console.error(

        'An unexpected error occurred while dispatching the variant change event for the product installment form.',

        error

      );

    }

  }



    /**
     * Update selected option name label
     */
  updateOptionLabel(form) {
    if (!this.currentVariant) return;
    
      form.querySelectorAll('[data-optionindex]').forEach(option => {
        const label = option.querySelector('.selected-option');
        if(label) label.textContent = this.currentVariant[`option${option.dataset.optionindex}`];
      });
     
      let variantColor = this.currentVariant?.option1;
      variantColor = variantColor.toLowerCase();
      form.querySelectorAll("[data-variant-color]").forEach(color=>{
        let colorOption = color.getAttribute("data-variant-color");
        if(variantColor == colorOption){
          color.style.opacity = '1';
        }else{
          color.style.opacity = '0';
        }
      });
    }

    _manageAccessoriesItem(form){
      if (!this.currentVariant) return
      if(this.currentVariant?.price && form && form.querySelector("[data-variant-price]")){
        form.querySelector("[data-variant-price]").setAttribute("data-variant-price", this.currentVariant?.price);
        // form.querySelector("[data-variant-price]").setAttribute("data-variant-compare_price", this.currentVariant?.compare_at_price);
        var comparePrice =  this.currentVariant?.compare_at_price;
        form.querySelector("[data-variant-price]").setAttribute("data-variant-compare_price", comparePrice != null ? comparePrice : this.currentVariant.price);
      }
      if (
        form &&
        form.closest('[data-format="product-page"]') &&
        document.querySelectorAll('[data-accessories-item]').length > 0 &&
        this.currentVariant
      ) {
        const { option1 = '', option2 = '', option3 = '' } = this.currentVariant;
        const opts = [option1, option2, option3].map(opt => opt?.toLowerCase() || '');


        if (document.querySelectorAll("[data-dispender-buy-btn]").length > 0) {
          document.querySelectorAll("[data-dispender-buy-btn]").forEach(ele=>{ele.value = this.currentVariant.id})
        }

        if (!window.hasUserModifiedAccessoryVariants) {
        document.querySelectorAll('[data-accessories-item]').forEach(item => {
          // Handle radio buttons
          const radios = item.querySelectorAll('[data-radio-box]');
          if (radios.length > 0) {
            radios.forEach(radio => {
              if (radio?.value) {
                const val = radio.value.toLowerCase();
                if(opts[0] == "essential series - black" || opts[0] == "essential series - white"){
                  if(val == "essential series - black/white" || val == "black/white"){
                    radio.checked = true;
                    radio.dispatchEvent(new Event('change', { bubbles: true }));

                    setTimeout(() => {
                      const select = document.querySelector("[data-water-bowl-product]")?.querySelector('[data-optionindex="2"] [data-select-box]');
                      if (select) {
                        select.value = "Standard & Elevated"; // or the real option value
                        select.dispatchEvent(new Event("change", { bubbles: true }));
                      }
                    }, 2000);

                    const wrapper = radio.closest("[data-accessories-item]");
                    if (wrapper) {
                      const colorWrapper = wrapper.querySelector("[data-color-label]");
                      const valueEl = colorWrapper?.querySelector("[data-color-value]");

                      if (valueEl) {
                        valueEl.innerText = radio.value;
                      }
                    }
                  }
                }else{
                  if (opts.some(opt => opt.includes(val))) {
                    radio.checked = true;
                    radio.dispatchEvent(new Event('change', { bubbles: true }));

                    setTimeout(() => {
                      const select = document.querySelector("[data-water-bowl-product]")?.querySelector('[data-optionindex="2"] [data-select-box]');
                      if (select) {
                        select.value = "Standard"; // or the real option value
                        select.dispatchEvent(new Event("change", { bubbles: true }));
                      }
                    }, 2000);

                    const wrapper = radio.closest("[data-accessories-item]");
                    if (wrapper) {
                      const colorWrapper = wrapper.querySelector("[data-color-label]");
                      const valueEl = colorWrapper?.querySelector("[data-color-value]");

                      if (valueEl) {
                        valueEl.innerText = radio.value;
                      }
                    }
                  }
                }
              }
            });
          }

          // Handle select boxes
          const selects = item.querySelectorAll('[data-select-box]');
          if (selects.length > 0) {
            selects.forEach(select => {
              if (select?.options) {
                Array.from(select.options).forEach((opt, i) => {
                  if (opt?.value) {
                    const val = opt.value.toLowerCase();
                    if (opts.some(o => o.includes(val))) {
                      select.selectedIndex = i;
                      select.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                  }
                });
              }
            });
          }
        });
        }
      };

      const accessoriesItem = form.closest("[data-accessories-item]");
      if (accessoriesItem) {
        const colorOptionWrapper = accessoriesItem.querySelector("[data-color-option-value]");
        if (colorOptionWrapper) {
          const colorOptionValEl = colorOptionWrapper.querySelector("[data-color-option-val]");
          if (colorOptionValEl) {
            const colorOption = colorOptionValEl.innerText;
            const colorValueEl = accessoriesItem.querySelector("[data-color-value]");
            if (colorValueEl) {
              colorValueEl.innerText = colorOption;
            }
          }
        } else {
          const colorLabel = accessoriesItem.querySelector("[data-color-label]");
          if (colorLabel) {
            colorLabel.classList.add("d-none");
          } 
        }
      }

      if (window.globalSpace?.template === 'product' && window.globalSpace?.templateSuffix === 'kibble' || window.globalSpace?.templateSuffix === 'product-abtest') {
        this.calculateSubtotal();
      }
    }
  
    calculateSubtotal() {
      let subtotalPrice = 0;
      let compareAtTotal = 0;
      let bundlePrice = 0;
      let bundleCompareAtPrice = 0;
      let mainkibbleproductprice = 0;
      let mainkibbleproductcompareatprice = 0;
    
      const priceElements = document.querySelectorAll("[data-product-price]");

      if (!priceElements.length) return;

      priceElements.forEach((priceEle) => {
        // Skip hidden prices
        if (priceEle.classList.contains("d-none")) return;
    
        const accessoriesWrap = priceEle.closest("[data-accessories-wrap]");
    
        if (accessoriesWrap) {
          const checkbox = accessoriesWrap.querySelector("[data-accessories-checkbox]");
    
          const variantPriceEl = accessoriesWrap.querySelector("[data-variant-price]");
          if (!variantPriceEl) return;

          const usePlainAccessoryPrice = Utility.shouldUsePlainAccessoryPrice(accessoriesWrap, priceEle);

          let price = usePlainAccessoryPrice
            ? parseInt(variantPriceEl.getAttribute("data-variant-price"), 10)
            : variantPriceEl.getAttribute("data-variant-compare_price");
          let compareAtPrice = variantPriceEl.getAttribute("data-variant-compare_price");

          if (price == null || price === '') return;
          price = parseInt(price);

          const originalPrice = price;

          const quantityInput = accessoriesWrap.querySelector("input[name='quantity']");
          if (quantityInput) {
            price = originalPrice * quantityInput.value;
          }

          const discountPercentageAttr = usePlainAccessoryPrice
            ? null
            : priceEle.getAttribute("data-discount-percentage");
          const discountPercentage = parseFloat(discountPercentageAttr);

          if (!usePlainAccessoryPrice && !isNaN(discountPercentage)) {
            const discountAmount = price * (discountPercentage / 100);
            price -= discountAmount;
          }

          if (checkbox && checkbox.checked) {
            subtotalPrice += price;
            if(!checkbox.closest("[data-bowl-product]")) {
              bundlePrice += price;
            }
          }

          // Update displayed price
          const isWaterBowlFree =
            accessoriesWrap.hasAttribute('data-water-bowl-product') && price === 0;
          if (isWaterBowlFree) {
            const freeLabel =
              priceEle.getAttribute('data-accessory-promo-price-free') || 'FREE';
            priceEle.textContent = freeLabel;
          } else {
            priceEle.innerHTML = `+${Utility.formatMoney(price, window.globalSpace.money_format)}`;
          }
          // Handle compare at price display
          // const comparePriceEl = accessoriesWrap.querySelector("[data-product-compare_price]");
          // if (comparePriceEl ) {
          //   console.log("compareAtPrice", compareAtPrice, price);
          //   if (compareAtPrice && compareAtPrice !== price) {
          //     comparePriceEl.classList.remove("d-none");
          //     comparePriceEl.innerHTML = `$${compareAtPrice.toFixed(2)}`;
          //   } else {
          //     if(compareAtPrice != null){comparePriceEl.classList.add("d-none"); }
          //   }
          // }

          const comparePriceElement = accessoriesWrap.querySelector("[data-product-compare_price]");
          if (!comparePriceElement) return;

          let showComparePrice = false;
          let comparePriceValue = 0;

          if (!usePlainAccessoryPrice && !isNaN(discountPercentage)) {
            const discountAmount = price * (discountPercentage / 100);
            if (discountAmount && discountAmount !== originalPrice) {
              showComparePrice = true;
              comparePriceValue = compareAtPrice;
            } else if (compareAtPrice && compareAtPrice !== price) {
              showComparePrice = true;
              comparePriceValue = compareAtPrice;
            }
          } else if (usePlainAccessoryPrice) {
            const variantUnitPrice = parseInt(variantPriceEl.getAttribute("data-variant-price"), 10);
            const compareAtUnitPrice = parseInt(compareAtPrice, 10);
            if (compareAtUnitPrice > variantUnitPrice) {
              showComparePrice = true;
              comparePriceValue = compareAtPrice;
            }
          } else if (compareAtPrice && compareAtPrice !== price) {
            showComparePrice = true;
            comparePriceValue = compareAtPrice;
          }

          if (showComparePrice && comparePriceValue != null) {
            comparePriceElement.classList.remove("d-none");
            if (quantityInput) {
              comparePriceValue = comparePriceValue * quantityInput.value;
            }
            if (window.globalSpace?.template === 'product' && window.globalSpace?.templateSuffix === 'product-abtest') {
            if(checkbox.closest("[data-bowl-product]")) {
              comparePriceElement.innerHTML = Utility.formatMoney(comparePriceValue, window.globalSpace.money_format);
              }else{
                comparePriceElement.innerHTML = Utility.formatMoney(comparePriceValue, window.globalSpace.money_format) + " " + window.globalSpace.currency_code;
              }
            }else{
              comparePriceElement.innerHTML = Utility.formatMoney(comparePriceValue, window.globalSpace.money_format);
            }
            if (checkbox && checkbox.checked) {
              compareAtTotal += parseInt(comparePriceValue);

              if(!checkbox.closest("[data-bowl-product]")) {
                bundleCompareAtPrice += parseInt(comparePriceValue);
              }
            }
          } else {
            comparePriceElement.classList.add("d-none");
          }
    
        } else {
          // Simple price element (not accessory)
          const price = priceEle.getAttribute('data-product-price');
          if (!price) return;

          subtotalPrice += parseInt(price);
          mainkibbleproductprice += parseInt(price);

          let compareAtPrice = document.querySelectorAll('[data-product-container] [data-compareprice]');
          compareAtPrice.forEach(el => {
            const comparePrice = el.getAttribute('data-compare-at-price');
            compareAtTotal += parseInt(comparePrice);
            mainkibbleproductcompareatprice += parseInt(comparePrice);
          });
        }
      });

      // Update subtotal display
      document.querySelectorAll('[data-product-sub-total]').forEach((subtotalEl) => {
        subtotalEl.innerHTML = `${Utility.formatMoney(subtotalPrice, window.globalSpace.money_format)} ${window.globalSpace.currency_code}`;
      });

      const mainkibbleproductpriceEl = document.querySelector("[data-product-only-sub-total]");
      if (mainkibbleproductpriceEl) {
        mainkibbleproductpriceEl.innerHTML = `${Utility.formatMoney(mainkibbleproductprice, window.globalSpace.money_format)} ${window.globalSpace.currency_code}`;
      }

      const mainkibbleproductcompareatpriceEl = document.querySelector("[data-product-only-compare-total]");
      if (mainkibbleproductcompareatpriceEl) {
        mainkibbleproductcompareatpriceEl.innerHTML = `${Utility.formatMoney(mainkibbleproductcompareatprice, window.globalSpace.money_format)} ${window.globalSpace.currency_code}`;
      }

      const bundleSubtotalEl = document.querySelector("[data-product-bundle-sub-total]");
      if (bundleSubtotalEl) {
        bundleSubtotalEl.innerHTML = `${Utility.formatMoney(bundlePrice, window.globalSpace.money_format)} ${window.globalSpace.currency_code}`;
      }

      const bundleCompareAtTotalEl = document.querySelector("[data-product-bundle-compare-total]");
      if (bundleCompareAtTotalEl) {
        bundleCompareAtTotalEl.innerHTML = `${Utility.formatMoney(bundleCompareAtPrice, window.globalSpace.money_format)} ${window.globalSpace.currency_code}`;
      }

      // Update button label
      const addToCartBtn = document.querySelector("[data-buy-dispenser-btn] .add-text");
      if (addToCartBtn) {
        if(document.querySelector(".product_houndsy-kibble-dispenser") != null){
          addToCartBtn.innerHTML = `Buy Now - ${Utility.formatMoney(subtotalPrice, window.globalSpace.money_format)} ${window.globalSpace.currency_code}`;
        }else{
          addToCartBtn.innerHTML = `Add to cart - ${Utility.formatMoney(subtotalPrice, window.globalSpace.money_format)} ${window.globalSpace.currency_code}`;
        }
        
      }

      // Show total compare-at price if it's different
      const compareAtCents = compareAtTotal;
      const compareAtTotalEl = document.querySelector("[data-product-compare-total]");
      if (compareAtTotalEl) {
        if (compareAtCents > subtotalPrice) {
          compareAtTotalEl.classList.remove("d-none");
          compareAtTotalEl.innerHTML = `${Utility.formatMoney(compareAtCents, window.globalSpace.money_format)} ${window.globalSpace.currency_code}`;
        } else {
          compareAtTotalEl.classList.add("d-none");
        }
      }

      Utility.syncProductInstallmentSubtotal(subtotalPrice);
    }

    /**
     * Store the all the variants json
     */
    _getVariantData() {
      if (!this.variant_json) {
        this.variant_json = this.querySelector('[data-variantJSON]');
      }
      if (!this.variant_json?.textContent?.trim()) {
        return [];
      }
      this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
      return this.variantData;
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
    
    get optionValues() {
      return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
        ({ dataset }) => dataset.optionValueId
      );
    }
}
customElements.define('variant-selects', VariantSelects);